import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { SaveAsTemplateButtonProps } from './SaveAsTemplateButtonTypes';

const SaveAsTemplateButton = ({
  onClick,
  label = 'Zapisz jako szablon',
  sx,
}: SaveAsTemplateButtonProps) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, ...sx }}>
    <Button variant="outlined" onClick={onClick}>
      {label}
    </Button>
  </Box>
);

export default SaveAsTemplateButton;
